var exports = {
  "Ac": "x9245d464--c0b8b5--popover-content",
  "fL": "x9245d464--c0b8b5--popover-list",
  "lr": "x9245d464--c0b8b5--popover-list-item",
};

module.exports = exports;
